export default "__VITE_ASSET__B$bzyoo8__"